import { isSegmentOp } from './isSegmentOp';
import type { Clause } from './types';

export function hasSegmentOp(clause: Clause) {
  return isSegmentOp(clause.op);
}
